module.exports = __webpack_public_path__ + "img/grouping.55f89d9d.jpg";